import httpClient from "./httpClient";
import { connectSocket, disconnectSocket } from "./socket";
import { isTokenExpired } from "../utils/session";

const TOKEN_KEY = "cbrne_token";
const USER_KEY = "cbrne_user";

const AuthService = {
  async login(email, password) {
    const { data } = await httpClient.post("/auth/login", { email, password });
    if (data?.token) {
      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem(USER_KEY, JSON.stringify(data.member));
      connectSocket();
    }
    return data;
  },

  async changePassword(currentPassword, newPassword) {
    const { data } = await httpClient.post("/auth/change-password", { currentPassword, newPassword });
    return data;
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    disconnectSocket();
  },

  // Re-reads the signed-in user's leadsIncident flag from /auth/me into the stored user.
  // Resolves true when it changed, so callers know to re-render.
  async refreshUser() {
    const stored = AuthService.getUser();
    if (!stored) return false;
    const { data } = await httpClient.get("/auth/me");
    const leadsIncident = Boolean(data?.leadsIncident);
    if (Boolean(stored.leadsIncident) === leadsIncident) return false;
    localStorage.setItem(USER_KEY, JSON.stringify({ ...stored, leadsIncident }));
    return true;
  },

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  getUser() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY));
    } catch {
      return null;
    }
  },

  isAuthenticated() {
    const token = AuthService.getToken();
    return Boolean(token) && !isTokenExpired(token);
  },
};

export default AuthService;
